import { BreezeIntelligenceEnrichmentProvider } from '../../BreezeIntelligenceEnrichmentProvider/BreezeIntelligenceEnrichmentProvider';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Contextual provider for the SmartPropertiesPanel.
 *
 * This sets up the current user, settings, credits, and design system.
 */
export function SmartPropertiesPanelProvider({
  children
}) {
  return /*#__PURE__*/_jsx(BreezeIntelligenceEnrichmentProvider, {
    children: children
  });
}